// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignCreationSlideContainer_container__2TifR"};